import React from 'react'

import Image from 'next/image'

import sprite from '@restaurantclub/svg-client-icons'

import styles from './Icon.module.css'

interface IconProps {
  className?: string
  icon: string
  width?: number
  height?: number
  imgWidth?: number
  imgHeight?: number
  alt?: string
}

const Icon: React.FC<IconProps> = ({ className, icon, width = 24, height = 24, imgWidth = 16, imgHeight = 16, alt }) => (
  <div className={styles.iconContainer} style={{ width, height }}>
    <Image src={`${sprite}#${icon}`} className={`iconImg ${className}`} alt={alt || icon} width={imgWidth} height={imgHeight} unoptimized />
  </div>
)

export default Icon
